import React from "react";

import { MdModeEdit } from "react-icons/md";

import designSystemColors from "../../../styles";
import { capitalize } from "../../../utils/capitalize";
import { customerStatus } from "../../../utils/customerStatus";

interface Dependent {
  id: number;
  idGrauParentesco: number;
  nome: string;
  cpf: string;
  dataNascimento: string;
  areaTelefone: string;
  numeroTelefone: string;
  nomeMae: string;
  status: number;
  nomeSocial: string;
}

type CardDependent = {
  dependent: Dependent;
  hasPermissionView: boolean;
  formatedDate: string;
  showMoreItems: boolean;
  grauParentesco: string;
  isViewMore: boolean;
  openEditModal: () => void;
  hasPermissionToEdit: boolean;
};

const CardDependent = ({
  dependent,
  hasPermissionView,
  formatedDate,
  showMoreItems,
  grauParentesco,
  isViewMore,
  openEditModal,
  hasPermissionToEdit,
}: CardDependent) => {
  return (
    <div
      className={isViewMore ? "content-user" : "grid-user__item"}
      style={{
        boxShadow: isViewMore ? "0px 0px 10px 0px rgba(0,0,0,0.1)" : "none",
        padding: isViewMore ? "1rem 2rem" : "1rem",
        borderRadius: isViewMore ? "0.5rem" : "0",
        wordWrap: isViewMore ? "break-word" : "normal",
      }}
      key={dependent.id}
    >
      {hasPermissionView && (
        <div
          className={isViewMore ? "content-user__id" : "client-id"}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "0.5rem",
          }}
        >
          <p>
            #{dependent.id}{" "}
            {dependent.idGrauParentesco &&
              `- ${grauParentesco[dependent.idGrauParentesco]}`}
          </p>
          {dependent.nomeSocial && <p>- Nome Social:</p>}
        </div>
      )}
      <div
        className={isViewMore ? "content-user__name" : "client-name"}
        style={{
          paddingRight: isViewMore ? "1rem" : "0",
          wordWrap: isViewMore ? "break-word" : "normal",
          display: "flex",
          alignItems: "center",
        }}
      >
        {dependent.nomeSocial ? (
          <div>
            <p
              style={{
                maxWidth: isViewMore ? "85%" : "70%",
              }}
            >
              {capitalize(dependent.nomeSocial)}
            </p>
          </div>
        ) : (
          <p
            style={{
              maxWidth: isViewMore ? "85%" : "70%",
            }}
          >
            {capitalize(dependent.nome)}
          </p>
        )}

        <span className={customerStatus(dependent.status).toLocaleLowerCase()}>
          {customerStatus(dependent.status)}
        </span>

        {hasPermissionToEdit && (
          <MdModeEdit
            title="Editar Dependente"
            onClick={openEditModal}
            color="gray"
            size={24}
            style={{
              color: designSystemColors.generalButtons,
              cursor: "pointer",
              marginLeft: "10px",
            }}
          />
        )}
      </div>

      {hasPermissionView && (
        <div
          className={
            isViewMore
              ? "content-user__infos"
              : `client-more-infos ${showMoreItems ? "active" : ""}`
          }
        >
          {dependent.cpf && (
            <p>
              <span>CPF:</span>{" "}
              {dependent.cpf.replace(
                /(\d{3})(\d{3})(\d{3})(\d{2})/,
                "$1.$2.$3-$4"
              )}
            </p>
          )}
          {formatedDate && (
            <p>
              <span>Nasc.:</span> {formatedDate}
            </p>
          )}
          {dependent.areaTelefone && dependent.numeroTelefone && (
            <p>
              <span>Tel.:</span>{" "}
              {`(${dependent.areaTelefone}) ${dependent.numeroTelefone}`}{" "}
            </p>
          )}
          {dependent.nomeMae && (
            <p>
              <span>Mãe:</span> {capitalize(dependent.nomeMae)}
            </p>
          )}
          {dependent.nomeSocial && (
            <p>
              <span>Nome:</span> {capitalize(dependent.nome)}
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default CardDependent;
